export const capitalizeFirstLetter = (s: string | undefined): string =>
  s ? s[0].toUpperCase() + s.slice(1) : '';

export const capitalizeOnlyFirstLetter = (s: string | undefined): string =>
  s ? s[0].toUpperCase() + s.slice(1).toLowerCase() : '';

export const lowerCaseFirstLetter = (s: string | undefined): string =>
  s ? s[0].toLowerCase() + s.slice(1) : '';
